/**
 * Pre-compiled es messages for Avatar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  avatarLabel: (args: Record<string, string | number>) =>
    `Imagen de avatar para ${args.fullName}`,
  avatarLabelGeneric: `Generic user avatar`,
};
